import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter'; 
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class RoomFunctions extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			FUNCTION_NAME: ''
		};
		
		var initialFunctionList = this.copyFunctionList();
		initialFunctionList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			functionList: initialFunctionList,
			search: search,
			searchCount: null
		};
	}
	
	copyFunctionList() {
		var functionListCopy = this.copyObject(functionList);
		for (var i = 0; i < functionList.columns.length; i++) {
			if (functionList.columns[i].Header) {
				functionListCopy.columns[i].Header = functionList.columns[i].Header;
			}
			if (functionList.columns[i].Cell) {
				functionListCopy.columns[i].Cell = functionList.columns[i].Cell;
			}
		}
		return functionListCopy;
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newFunctionList = this.copyFunctionList();
		newFunctionList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			functionList: newFunctionList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.FUNCTION_NAME)) search.Children.push({ Attribute: 'FUNCTION_NAME', Operator: 'like', StringValue: '%' + data.FUNCTION_NAME + '%' });
		search.Children.push({ Attribute: 'DELETE_FLAG', Operator: 'is null' });
		
		return search;
	}
	
	addRoomFunction() {
		this.props.navigate('/BuildingAccess/RoomFunctions/new');
	}
	
	editRoomFunction(roomFunctionId) {
		this.props.navigate('/BuildingAccess/RoomFunctions/' + roomFunctionId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Room Functions',
			columns: exportColumns,
			entity: 'ROOM_FUNCTION',
			search: this.constructSearch(this.state.search),
			order: 'FUNCTION_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Room Functions</span>
					<ChemEdit parent={this} columns={functionSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_RoomFunctions' table={this.state.functionList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='180px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const functionSearch = [
	{ Header: 'Function Name', accessor: 'FUNCTION_NAME' }
];

const functionList = {
	query: { 
		entity: 'ROOM_FUNCTION', 
		search: { Attribute: 'DELETE_FLAG', Operator: 'is null' },
		order: 'FUNCTION_NAME'
	},
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addRoomFunction()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editRoomFunction(props.row.values.FUNCTION_ID)} />, width: 25 },
		{ Header: '', accessor: 'FUNCTION_ID', show: false },
		{ Header: 'Function Name', accessor: 'FUNCTION_NAME', width: 300 }
	]
};

const exportColumns = [
	{ Header: 'Function Name', accessor: 'FUNCTION_NAME', width: 20 }
];

export default withRouter(RoomFunctions);